const crop_type_varieties = [
    "early",
    "extraEarly",
    "normal",
    "late",
    "extraLate"
];
export default crop_type_varieties;